export interface Diacritics {
  diacritics: RegExp;
  letter: string;
}
